import React, { useRef, useState } from 'react';

const validFileExtensions = ['.png', '.jpg', '.jpeg', '.gif'] as const;

interface GlossaryTermImageUploadProps {
  field: {
    value: any;
    onChange: (e: any) => void;
  }
  glossary_image_file_name: string;
  onImageRemoved: (removed: boolean) => void;
}

const GlossaryTermImageUpload = ({ field, glossary_image_file_name, onImageRemoved }: GlossaryTermImageUploadProps) => {
  const [removed, setRemoved] = useState(false);
  const inputRef = useRef(null);
  const fileName = field.value?.name || (!removed && glossary_image_file_name) || null;

  return (
    <div className="tw-flex tw-items-center">
      <input
        ref={inputRef}
        accept={validFileExtensions.join(',')}
        style={fileName ? { color: 'transparent' } : {}}
        type="file"
        onChange={(e) => {
          setRemoved(false);
          onImageRemoved(false);
          field.onChange(e.target.files[0]);
        }}
      />
      {fileName && (
        <span className="tw-flex tw-items-center tw-translate-x-[-10.75rem]">
          <span>{fileName}</span>
          <button
            className="tw-text-xl tw-cursor-pointer tw-ml-1 tw-mt-1 tw-text-red"
            style={{ background: 'none', border: 'none', padding: 0 }}
            title="Remove image"
            type="button"
            onClick={() => {
              field.onChange(null);
              setRemoved(true);
              onImageRemoved(true);
              if (inputRef.current) inputRef.current.value = '';
            }}
          >
            &times;
          </button>
        </span>
      )}
    </div>
  );
};

export default GlossaryTermImageUpload;
